module.exports = __webpack_public_path__ + "img/GA_full.28a1b5e3.jpg";